var map = {
	"./blackGold/fragments/arrowvector.png": 86741,
	"./brownGold/fragments/arrowvector.png": 6750,
	"./darkBlue/fragments/arrowvector.png": 54204,
	"./greenYellow/fragments/arrowvector.png": 73348,
	"./redGold/fragments/arrowvector.png": 77363,
	"./skyBlue/fragments/arrowvector.png": 79960,
	"./whiteGold/fragments/arrowvector.png": 12912,
	"./yellowWhite/fragments/arrowvector.png": 78975
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17759;